<template>
  <div>
    <v-overlay :value="isGuideForUser"></v-overlay>
    <!-- VNavigationDrawer - Vuetify -->
    <v-skeleton-loader
      :loading="false"
      transition="scale-transition"
      :boilerplate="false"
      type="table"
      class="mx-auto"
    >
      <v-navigation-drawer
        v-model="isOpen"
        :mini-variant.sync="mini"
        :permanent="!isMobile"
        class="text-left pt-3 border-none"
        :class="[isGuideForUser ? 'pointer-events-none' : '']"
        :expand-on-hover="expandOnHover"
        mobile-breakpoint="960"
        color="#f9f9f9"
        app
        width="280"
        v-bind="$attrs"
      >
        <template>
          <router-link to="/" class="pl-2 flex items-center space-x-1 mb-1">
            <!-- <logo /> -->
            <img src="../../assets/logo/logo.png" alt="logo" class="w-20 mb-5" />
            <p class="text-h6 font-weight-bold orange--text mb-3 brand">LÊ PHONG MOBILE</p></p>
          </router-link>
        </template>
        <!-- VList - Vuetify -->
        <v-list expand nav>
          <!-- Item.vue - molecules component-->
          <v-fade-transition group>
            <template v-for="(item, i) in computedItems">
              
              <ItemGroup
                v-if="item.children"
                :key="`group-${i}`"
                :item="item"
                :tooltipContent="tooltipContent"
                :enableTooltip="isGuideForUser"
                :active="currentStep === i"
                :currentStep="currentStep"
                :nextStep="nextStep"
              />
              <!-- Item.vue - molecules component-->
              <item
                v-else
                :key="`item-${i}`"
                :item="item"
                :tooltipContent="tooltipContent"
                :enableTooltip="isGuideForUser"
                :active="currentStep === i"
                :currentStep="currentStep"
                :nextStep="nextStep"
              />
            </template>
          </v-fade-transition>
        </v-list>
        <template v-slot:append>
          <!-- Item.vue - molecules component-->
         
          <v-list-item
            v-if="!mini && !isMobile"
            class="h-12 cursor-pointer"
            @click.native="onClickExpand"
          >
            <!--VListItemIcon - Vuetify-->
            <v-list-item-icon>
              <v-icon>mdi-chevron-left</v-icon>
            </v-list-item-icon>
            <!--VListItemContent - Vuetify-->
            <v-list-item-content class="text-lg">
              Thu nhỏ
            </v-list-item-content>
          </v-list-item>
          <span v-if="!mini && !isMobile" class="text-center text-xs text-grey mx-auto">
            <p class="mb-0">Copyright © 2023</p>
            <p>Bản quyền thuộc về Lê Phong Mobile</p>
          </span>
        </template>
      </v-navigation-drawer>
    </v-skeleton-loader>
  </div>
</template>

<script>
// Utilities
import { mapMutations, mapGetters, mapState } from "vuex";
import { EMPTY, STEP_BY_STEP, PATH } from "~/utils/constants";

export default {
  name: "SideBar",

  components: {
    Item: () => import("~/components/molecules/Item"),
    ItemGroup: () => import("~/components/molecules/ItemGroup"),
    logo: () => import("~/components/logos/Logo"),
  },

  props: {
    expandOnHover: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      role: EMPTY,
      isLoading: false,
      mini: false,
      items: [
        {
          icon: "mdi-view-dashboard-outline",
          title: "Tổng quan",
          to: PATH.HOME,
          roles: ["Admin"],
          children: null,
        },
        {
          icon: "mdi-elevator",
          title: "Sửa chữa",
          to: PATH.PHONE_FIX,
          roles: ["Admin", "BacSy", "LeTan", "QuanLy", "BocThuoc", "SacThuoc"],
          children: null,
        },
        {
          icon: "mdi-bell-badge",
          title: "Bảo hành",
          to: PATH.PHONE_BUY,
          roles: ["Admin", "BacSy", "BocThuoc", "SacThuoc", "QuanLy"],
          children: null,
        },,
        {
          icon: "mdi-application-import",
          title: "Nhập file",
          to: PATH.NHAP_FILE,
          roles: ["Admin", "BacSy", "BocThuoc", "SacThuoc", "QuanLy"],
          children: null,
        }
      ],
    };
  },

  async created() {
    this.mini = true;
    try {
      const data = await this.$services.commonService.getUserRole();
      this.role = data?.userRole;
      this.$store.commit("user/setUserRole", this.role);
    } catch (err) {
    } finally {
      this.mini = false;
    }
  },

  computed: {
    ...mapState({
      currentStep: (state) => state.stepByStep.current,
    }),
    ...mapGetters({
      isGuideForUser: "isGuideForUser",
    }),
    isOpen: {
      get() {
        return this.$store.state.sidebar.isOpen;
      },
      set(val) {
        this.$store.commit("sidebar/TOGGLE_SIDEBAR", val);
      },
    },
    computedItems() {
      return this.items.filter((element) => element.roles.includes(this.role));
    },
    profile() {
      return {
        avatar: true,
        title: "avatar",
      };
    },
    isMobile() {
      return window.innerWidth < 1024;
    },
    tooltipContent() {
      let retValue = {};
      if (this.isGuideForUser) {
        retValue = STEP_BY_STEP.find(
          (element) => element.path === this.computedItems[this.currentStep]?.to
        );
      }
      return retValue?.content || EMPTY;
    },
    nextStep() {
      return this.computedItems.length - 1 === this.currentStep
        ? null
        : this.currentStep + 1;
    },
  },

  methods: {
    ...mapMutations("sidebar", {
      toggleSidebar: "TOGGLE_SIDEBAR",
    }),
    onClickExpand() {
      console.log("🚀 ~ file: SideBar.vue:290 ~ onClickExpand ~ onClickExpand:")
      this.mini = !this.mini;
      this.toggleSidebar(!this.isOpen);
    },
  },
};
</script>

<style lang="sass" scoped>
@import '~vuetify/src/styles/tools/_rtl.sass'
.v-list-item
  font-size: 18px

.v-list-item--active
  color: black !important
  background-color: #c8c8c8 !important
  font-weight: bold

.v-list-item--link:before
  background-color: transparent !important

.brand 
  font-size: 30px !important
</style>
